"use client";

import * as React from "react";
import { AlertOctagon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-4 p-8 text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
            <AlertOctagon className="h-7 w-7" />
          </div>
          <div className="space-y-1">
            <h2 className="text-2xl font-semibold tracking-tight">Coś poszło nie tak</h2>
            <p className="text-sm text-muted-foreground">
              {error.message || "Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę."}
            </p>
            {error.digest && (
              <p className="font-mono text-xs text-muted-foreground/70">
                Digest: {error.digest}
              </p>
            )}
          </div>
          <div className="flex justify-center gap-2">
            <Button onClick={() => reset()}>Spróbuj ponownie</Button>
            <Button
              variant="outline"
              onClick={() => {
                if (typeof window !== "undefined") {
                  window.location.href = "/";
                }
              }}
            >
              Strona główna
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
